export default "__VITE_ASSET__C1BQ$JNk__"